import { useCurrentUser } from '@zapier/upsells/src/hooks';
import { ApolloInjection } from '@zapier/upsells/src/types';

type UserCurrentAccountResult = {
  accountId: number | undefined;
  error: string | undefined;
  isLoading: boolean;
};

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useCurrentAccountId = ({
  skip,
  useQuery,
}: Props = {}): UserCurrentAccountResult => {
  const { currentUser, error, isLoading } = useCurrentUser({
    skip,
    useQuery,
  });

  return {
    accountId: currentUser?.currentAccountId
      ? parseInt(currentUser.currentAccountId)
      : undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading,
  };
};
